/**
 * 404 Not Found page — catch-all for unmatched routes.
 * Placed at /* (TanStack Router notFound route).
 * Bare layout, no sidebar.
 */
import { createFileRoute, Link } from '@tanstack/react-router';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
});

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-5 px-4 text-center">
      <div className="text-7xl font-extrabold text-muted-foreground/20 select-none">404</div>

      <div className="space-y-1">
        <h1 className="text-2xl font-bold text-foreground">Trang không tìm thấy</h1>
        <p className="text-sm text-muted-foreground max-w-sm">
          Trang bạn đang tìm không tồn tại hoặc đã bị xóa.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
        <Button
          variant="outline"
          className="w-full sm:w-auto min-h-[44px] gap-2"
          onClick={() => window.history.back()}
        >
          <ArrowLeft className="h-4 w-4" />
          Quay lại
        </Button>
        <Link to="/">
          <Button className="w-full sm:w-auto min-h-[44px] gap-2">
            <Home className="h-4 w-4" />
            Trang chủ
          </Button>
        </Link>
      </div>
    </div>
  );
}
